import { useSystem } from 'core/common/store/hooks';
import { Image } from 'core/common/ui/ui-kit';
import { ScreenAttributes, ScreenBackground } from 'core/flow/entities';

export type BackgroundsProps = {
  attributes: ScreenAttributes[];
};

type Background = {
  mobile: string;
  desktop: string;
};

export const Backgrounds = ({ attributes }: BackgroundsProps) => {
  const { isMobileDevice } = useSystem();

  const urls: Background[] = [];

  attributes.forEach((attr) => {
    if ('content' in attr) {
      const background = attr.content?.backgroundImage as ScreenBackground;
      const mobile = background?.mobileImage?.src || '';
      const desktop = background?.desktopImage?.src || '';

      if (mobile || desktop) {
        urls.push({ desktop, mobile });
      }
    }
  });

  const backgrounds = urls?.map((url, i) => {
    if (url.mobile || url.desktop) {
      return (
        <Image
          fill
          key={url.mobile + i}
          quality={90}
          src={isMobileDevice ? url.mobile : url.desktop}
          alt="background-image"
        />
      );
    }

    return null;
  });

  return <>{backgrounds}</>;
};
